import {Parameter, ToolboxAnnotationAnnotation} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddToolboxAnnotation} from "./PortalAddToolboxAnnotation";

export class PortalToolboxAnnotationAnnotation extends ToolboxAnnotationAnnotation implements Parameter {
	public add?: PortalAddToolboxAnnotation;

	constructor(data: any) {
		super(data);

		this.add = PortalAddToolboxAnnotation.fromJson(data?.add);
	}

	public static fromJson(data: any): PortalToolboxAnnotationAnnotation {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxAnnotationAnnotation(data);
	}

	public clone(): PortalToolboxAnnotationAnnotation {
		return PortalToolboxAnnotationAnnotation.fromJson(this.toJson());
	}
}